import { render, staticRenderFns } from "./ShutterRussianLanguagePreview.vue?vue&type=template&id=087a981b&lang=pug&"
import script from "./ShutterRussianLanguagePreview.vue?vue&type=script&lang=js&"
export * from "./ShutterRussianLanguagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports